import { Component, OnInit, ViewChild, ViewEncapsulation, Inject } from '@angular/core';
import { Location } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { Session, HardwareCheckerService } from './services/index';
import { TranslateService } from '@ngx-translate/core';
import { SwitchComponent, ChangeEventArgs } from '@syncfusion/ej2-angular-buttons';
import { SidebarComponent } from '@syncfusion/ej2-angular-navigations';
import { ButtonComponent } from "@syncfusion/ej2-angular-buttons";
declare function redirectToPhs(isTest: boolean): any;


@Component({
  selector: 'app-root',
  styleUrls: ['sidebar.css'],
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
  isAuth: boolean = false;
  pathString: string;
  selectedIndex: number = 1;
  sessionJWT: string;
  showMenu: boolean = false;
  public width: string = '290px';
  mediaQuery: string = ('(min-width: 600px)');
  target: string = '.main-content';

  options = {
    timeOut: 2000,
    showProgressBar: false,
    lastOnBottom: true
  }
  @ViewChild('sidebar')
  public dockBar: SidebarComponent;
  // @ViewChild('togglebtn')
  // public togglebtn: ButtonComponent;


  public enableDock: boolean = true;
  // public width: string = '220px';
  public dockSize: string = '72px';

  loading = false;

  constructor(private route: ActivatedRoute,
    private location: Location,
    private router: Router,
    public session: Session,
    public hardwareChecker: HardwareCheckerService,
    public translate: TranslateService) {
    this.pathString = location.path();
    console.log('pathString:', this.pathString);
    this.isAuth = this.session.isAuthenticated;
    translate.setDefaultLang('en');
    translate.use('en');
    this.session.selectedLang = 'en';
    this.showMenu = true;

  }

  ngOnInit() {
    //this.dockBar.hide();
    if (this.pathString.lastIndexOf('jwt=') >= 0) {
      this.loading = true;
      let sessionJWT = this.pathString.substring(this.pathString.lastIndexOf('jwt=') + 4);
      let login = this.session.loginWithToken(sessionJWT)
        .subscribe(success => {
          this.loading = false;
          this.session.setAuthenticated(true);
          this.router.navigate(['/dashboard']);
        }, ex => {
          this.loading = false;
          console.log('Invalid Login Credentials');
        });
    } else if (this.pathString.lastIndexOf('auth') >= 0) {
      let userid = this.getURLParameter('userid');
      let userEmail = this.getURLParameter('email');
      let token = this.getURLParameter('token');
      let display = this.getURLParameter('display');
      this.loading = false;
      // this.router.navigate(['/auth'], { queryParamsHandling: "preserve" });   //this doesn't work and it should.
      this.router.navigate(['/auth'], { queryParams: { userid: userid, email: userEmail, token: token, display: display } });
    } else if (this.pathString.lastIndexOf('error') >= 0) {
      this.loading = false;
      let message = this.getURLParameter('error');
      console.log('error reached:', message);
      this.session.message = message;
      this.session.messageType = 'error';
      this.router.navigate(['/login'], { queryParams: { type: 'error', msg: message } });

    } else {
      this.loading = false;
      console.log('navgate to login');
      this.router.navigate(['/login']);
    }
    this.select(this.selectedIndex);
   
  }

  select(index: number) {
    console.log('----------------------------------------app.component.select Index:', index);
    this.selectedIndex = index;
  }
  logout() {
    redirectToPhs(false);
  }

  positionChange(args: any) {
   // this.dockBar.position = args.value == "left" ? "Left" : "Right";
  }
  toggleClick() {
    this.dockBar.toggle();
  }
  newTabClick(): void {
    document.getElementById('newTab').setAttribute('href', location.href.split('#')[0] + 'sidebar/responsive-panel');
  }
  public onCreated(args: any) {
    this.closeClick();
}
btnClick(){
  // if(this.togglebtn.element.classList.contains('e-active')){
  //     this.togglebtn.content = 'Open';
  //     this.dockBar.hide();
  // }
  //else{
      //this.togglebtn.content = 'Close';
  //    this.dockBar.show();
  //}
}
closeClick() {
   this.dockBar.hide();
  //  this.togglebtn.element.classList.remove('e-active');
  //  this.togglebtn.content = 'Open'
}
  openClick() {
    this.dockBar.toggle();
  }

  gotoHome() {
    
    this.router.navigate(['/dashboard']);
    this.closeClick();
  }
  gotoMedical() {
    var dockPos = this.dockBar.position;
   
     
    
    this.router.navigate(['/dashboard-medical/1']);
    this.closeClick();
  }
  gotoProfile() {
  
    this.router.navigate(['/dashboard-my-profile']);
    this.closeClick();
  }
  gotoFamily() {
    
    this.router.navigate(['/dashboard-family']);
    this.closeClick();
  }
  gotoHistory() {
   
    this.router.navigate(['/dashboard-medical-history']);
    this.closeClick();
  }
  gotoExamHistory() {
   
    this.router.navigate(['/dashboard-exam-history']);
    this.closeClick();
  }



  toggleMenu() {
    //this.showMenu = !this.showMenu;
  }

  //none of the activated route/snapshot parameter parsing worked so yes I brute forced this stupid shit.
  getURLParameter(name) {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(this.pathString) || [null, ''])[1].replace(/\+/g, '%20')) || null;
  }

  termsTapped() {
    let caredocurl = "http://memd.force.com/agreement/agreements?name=useagreement";
    let newWindow = window.open("about:blank", "_blank");
    newWindow.opener = null;
    newWindow.location.href = caredocurl;
  }

  privacyTapped() {
    let caredocurl = "http://memd.force.com/agreement/agreements?name=privacy";
    let newWindow = window.open("about:blank", "_blank");
    newWindow.opener = null;
    newWindow.location.href = caredocurl;
  }
  onChangeLan(args: ChangeEventArgs): void {
    if (args.checked === true) {
      this.translate.setDefaultLang('es');
      this.translate.use('es');
      this.session.changeLang('es');
    } else {
      this.translate.setDefaultLang('en');
      this.translate.use('en');
      this.session.changeLang('en');
    }

  }

}


